import MeqTable from "./MeqTable";
import type { MeqRowData, MeqTableProps } from "./types";

/**
 * Preset parity with the old wrapper's MinimalTable.tsx: no toolbar, no
 * pagination, no sorting, borderless. Used for small embedded tables (e.g.
 * detail-panel sub-tables) that just render rows.
 */
const MinimalMeqTable = <TData extends MeqRowData>(
  props: MeqTableProps<TData>,
) => (
  <MeqTable
    hasToolbar={false}
    hasBorder={false}
    hasSorting={false}
    hasPagination={false}
    {...props}
  />
);

export default MinimalMeqTable;
